var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "../Components/FormGroup.vue";
var Email = /** @class */ (function (_super) {
    __extends(Email, _super);
    function Email() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localEmail = _this.email || null;
        return _this;
    }
    Email.prototype.onEmailChanged = function (val) { this.$emit("update:email", val); };
    __decorate([
        Prop({ type: Object, required: true })
    ], Email.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], Email.prototype, "$v", void 0);
    __decorate([
        Prop({ type: String })
    ], Email.prototype, "email", void 0);
    __decorate([
        Watch("localEmail")
    ], Email.prototype, "onEmailChanged", null);
    __decorate([
        Prop({ type: String, default: "email" })
    ], Email.prototype, "mEmail", void 0);
    __decorate([
        Prop({ type: String, default: "email" })
    ], Email.prototype, "$vEmail", void 0);
    Email = __decorate([
        Component({
            name: "Email",
            components: {
                FormGroup: FormGroup
            }
        })
    ], Email);
    return Email;
}(Vue));
export default Email;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/Email.vue
// module id = 120
// module chunks = 2 3 4 6